import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Center, SimpleGrid } from '@chakra-ui/react'
import { useMonth } from '@datepicker-react/hooks'

import { Day } from '../day'
import { useDatePickerCore } from '../../context'

export const Month = ({ year, month }) => {
  const { formatAdapter } = useDatePickerCore()
  const { days, weekdayLabels, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek: formatAdapter.firstDayOfWeek,
    monthLabelFormat: formatAdapter.month,
    weekdayLabelFormat: formatAdapter.weekday,
    dayLabelFormat: formatAdapter.day,
  })

  return (
    <Flex direction='column' width='100%'>
      <Center lineHeight='2' fontWeight='600'>
        {monthLabel}
      </Center>

      <SimpleGrid marginTop='1.5rem' columns={7} fontSize='xs' color='gray.700' fontWeight='500'>
        {weekdayLabels.map((label, index) => (
          <Center key={index}>{label}</Center>
        ))}
      </SimpleGrid>

      <SimpleGrid marginTop='0.5rem' columns={7}>
        {days.map((day, index) =>
          typeof day === 'object' ? (
            <Day key={index} date={day.date}>
              {day.dayLabel}
            </Day>
          ) : (
            <div key={index} />
          ),
        )}
      </SimpleGrid>
    </Flex>
  )
}

Month.propTypes = {
  year: PropTypes.any,
  month: PropTypes.any,
}
